import React from 'react';
import { faqData } from '../mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';

const FAQ = () => {
  return (
    <div className="min-h-screen py-12" style={{ backgroundColor: '#f7f5f2' }}>
      <div className="container mx-auto px-4 max-w-4xl">
        {/* Page Header */}
        <div className="text-center mb-12">
          <h1 className="text-5xl md:text-6xl font-bold mb-4" style={{ color: '#4a2c1a', fontFamily: 'Georgia, serif' }}>
            Frequently Asked Questions
          </h1>
          <p className="text-xl" style={{ color: '#736c64' }}>
            Everything you need to know about our maple syrup
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="bg-white rounded-lg shadow-lg p-8">
          <Accordion type="single" collapsible className="w-full">
            {faqData.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left text-lg font-semibold hover:no-underline" style={{ color: '#4a2c1a' }}>
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-base leading-relaxed" style={{ color: '#736c64' }}>
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Contact CTA */}
        <div className="mt-12 text-center p-8 rounded-lg" style={{ backgroundColor: '#4a2c1a' }}>
          <h2 className="text-3xl font-bold mb-4" style={{ color: '#FF8C19' }}>
            Still have questions?
          </h2>
          <p className="text-lg mb-6" style={{ color: '#f7f5f2' }}>
            We're here to help! Reach out to us and we'll get back to you as soon as possible.
          </p>
          <a
            href="/contact"
            className="inline-block px-8 py-3 rounded-lg font-semibold text-white transition-opacity hover:opacity-90"
            style={{ backgroundColor: '#FF8C19' }}
          >
            Contact Us
          </a>
        </div>
      </div>
    </div>
  );
};

export default FAQ;